import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42fae441"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uppercase" }
const _hoisted_2 = { class: "uppercase" }

import { computed, PropType, Ref } from 'vue';
import { Annotation } from '@/entities/annotation/types';
import { useGetAnnotationHistoriesQuery } from '@/entities/annotation-history/hooks';
import { NkBadge, NkTable, NkTableColumn } from '@/core/components';
import { AnnotationHistoryRepresentation } from '@/entities/annotation-history/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnnotationHistoryViewer',
  props: {
  annotation: {
    type: Number as PropType<Annotation['id']>,
    required: true,
  }
},
  setup(__props) {

const props = __props



const annotationHistoryQueryData: Ref = computed(() => ({ annotation: props.annotation }));
const hasAnnotationHistoryQueryData = computed(() => !!annotationHistoryQueryData.value);
const {
  data,
  isLoading: annotationHistoryLoading
} = useGetAnnotationHistoriesQuery({
  enabled: hasAnnotationHistoryQueryData,
}, annotationHistoryQueryData);

const annotationHistory = computed(() => data.value?.reduce((acc: AnnotationHistoryRepresentation[], currentValue, currentIndex) => {
  let isSeverityChanged = false;
  let isTypeChanged = false;
  let historyStatus = currentValue.status

  if ( currentIndex !== 0 && currentValue.severity !== acc[currentIndex - 1].severity ) {
    isSeverityChanged = true;
  }

  if ( currentIndex !== 0 && currentValue.type !== acc[currentIndex - 1].type ) {
    isTypeChanged = true;
  }

  if ( historyStatus === 'updated' && currentIndex + 1 === data.value?.length ) {
    historyStatus = 'update'
  }

  acc.push({
    ...currentValue,
    status: historyStatus,
    isSeverityChanged,
    isTypeChanged
  });

  return acc;
}, []) ?? []);

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(NkTable), { data: _unref(annotationHistory) }, {
    default: _withCtx(() => [
      _createVNode(_unref(NkTableColumn), {
        prop: "status",
        label: "Status",
        width: "150"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_unref(NkBadge), {
            class: "status-tag",
            size: "sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(scope.row.status), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }),
      _createVNode(_unref(NkTableColumn), {
        prop: "date",
        label: "Date",
        width: "150"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(_ctx.$format(scope.row.date)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(NkTableColumn), {
        prop: "userName",
        label: "User"
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(scope.row.userName), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(NkTableColumn), {
        prop: "type",
        label: "Type"
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("p", {
            class: _normalizeClass({'highlight-change': scope.row.isTypeChanged })
          }, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(scope.row.type), 1)
          ], 2)
        ]),
        _: 1
      }),
      _createVNode(_unref(NkTableColumn), {
        prop: "severity",
        label: "Severity",
        width: "170"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_unref(NkBadge), {
            plain: "",
            size: "sm",
            color: scope.row.severityColor
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(scope.row.severity), 1)
            ]),
            _: 2
          }, 1032, ["color"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"])), [
    [_directive_loading, _unref(annotationHistoryLoading)]
  ])
}
}

})